import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import type { GenerationSalesPlanDetail } from '@ebalance/proto/bffuser/v1/generation_sales_plan_model_pb'
import { getGenerationSalesPlanDetail } from '@ebalance/proto/bffuser/v1/generation_sales_plan_service-GenerationSalesPlanService_connectquery'
import { GetGenerationSalesPlanDetailRequestSchema } from '@ebalance/proto/bffuser/v1/generation_sales_plan_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * GenerationSalesPlanService.GetGenerationSalesPlanDetail を呼ぶ hook。
 */
export function useGetGenerationSalesPlanDetail(
  id: string,
): UseQueryResult<{ detail?: GenerationSalesPlanDetail }, ConnectError> {
  return useQuery(
    getGenerationSalesPlanDetail,
    create(GetGenerationSalesPlanDetailRequestSchema, { id }),
    {
      enabled: id !== '',
    },
  )
}
